<template>
<div class="foot foot-box">
  <div class="foot-item left-box">
    <dv-border-box-8>
      <div class="foot-content">
        <div class="title">授信排行榜<div>金额(元)</div></div>
        <dv-scroll-board ref="scrollBoard1" :config="leftConfig" />
      </div>
    </dv-border-box-8>
  </div>

  <div class="foot-item right-box">
    <dv-border-box-8>
      <div class="foot-content">
        <div class="title">实时订单详情</div>
        <dv-scroll-board :config="rightConfig" @mouseover="mouseover" />
      </div>
    </dv-border-box-8>
  </div>
</div>
</template>

<script>
import {
  getCreditRanking,
  getRealTimeOrder
} from '../../../api/colunm4'
import { foot } from '../js/data'
export default {

  data () {
    return {
      leftConfig: foot.left,
      rightConfig: foot.right,
      timer1: null,
      timer2: null
    }
  },

  created () {
    this.getData1()
    this.getData2()
  },

  methods: {
    getData1 () {
      getCreditRanking().then(res => {
        const data = []
        res.sort((a, b) => {
          return b.value - a.value
        })
        res.forEach(element => {
          const temp = [element.name, element.value]
          data.push(temp)
        })
        this.leftConfig.data =  data
        this.leftConfig = { ...this.leftConfig }
        this.timer1 && clearInterval(this.timer1)
        this.timer1 = setTimeout(this.getData1, 1000 * 10)
      })
    },

    getData2 () {
      getRealTimeOrder().then(res => {
        const data = []
        res.forEach(element => {
          const temp = [element.name, element.value]
          data.push(temp)
        })
        this.rightConfig.data =  data
        this.rightConfig = { ...this.rightConfig }
        this.timer2 && clearInterval(this.timer2)
        this.timer2 = setTimeout(this.getData2, 1000 * 10)
      })
    },

    mouseover (e) {
      // console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.foot-box {
  display: flex;
  justify-content: space-between;
  height: 291px;
  .foot-item {
    width: 315px;
    height: 291px;
    background: linear-gradient(-21deg, rgba(14, 49, 115, 0.5), rgba(7, 20, 73, 0.5));
    .foot-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 13px 17px 10px 19px;
    }
  }
  .left-box {
    /deep/ .row-item {
      font-family: 'SourceHanSansCN-Regular';
      div {
        padding: 0;
      }
      div:nth-child(1) {
        padding-right: 10px;
      }
      div:nth-child(2) {
        flex-grow: 1;
      }
    }
  }
  .right-box {
    /deep/ .header {
      font-family: 'SourceHanSansCN-Regular';
      div {
        padding: 0;
      }
      .header-item {
        flex-grow: 1;
      }
    }
    /deep/ .row-item {
      font-family: 'SourceHanSansCN-Regular';
      div {
        padding: 0;
      }
      div:nth-child(1) {
        flex-grow: 1;
      }
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    color: #34DEE5;
    font-size: 21px;
    font-weight: bold;
  }
}
</style>